// extracted by mini-css-extract-plugin
export default {"container":"Notification_container__NXxnO","slideIn":"Notification_slideIn__PqbqX","header":"Notification_header__dj1jC","messsage":"Notification_messsage__pas4I"};